import { memo, type CSSProperties } from 'react';

import plusIconSc from '../../assets/plus_sc.png';
import plusIconScWebp from '../../assets/plus_sc.webp';

export const PlusIconSc = memo(
  ({ className, style, alt }: { className?: string; style?: CSSProperties; alt?: string }) => {
    return (
      <picture className={className} style={{ display: 'flex', ...style }}>
        <source srcSet={plusIconScWebp} type="image/webp" />
        <source srcSet={plusIconSc} type="image/png" />
        <img alt={alt || 'Plus icon'} src={plusIconSc} />
      </picture>
    );
  },
);

PlusIconSc.displayName = 'PlusIconSc';
